// Dependencies

// Styles
require("slick-carousel/slick/slick.scss");
require("./home-slider-1-1.scss");

// JavaScript
require("slick-carousel/slick/slick.min.js");
var $ = require("jquery");
var $slider = $('.home-slider-1-1');

$slider.each(function () {

    $(this).slick({
        arrows: true,
        infinite: true,
        dots: true,
        adaptiveHeight: true,
        autoplay: $(this).data("autoplay"),
        autoplaySpeed: $(this).data("autoplay-speed"),
        speed: 500,
        fade: $(this).data("fade"),
        cssEase: 'linear'
    });

});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/home-slider-1/view-1/index.js
// module id = 202
// module chunks = 0